<template>
  <div class="input-group">
    <input
      :type="input.addonType == 'text' ? 'text' : 'number'"
      :class="'form-control ' + input.class"
      :value="value"
      @change="(e) => handleChange(e)"
      :placeholder="input.placeholder"
      :required="!input.optional"
      :disabled="input.disabled"
      :readonly="input.readonly"
      :name="input.name"
      :v-mask="input.mask || ''"
    />
    <div class="input-group-append">
      <span class="input-group-text" v-html="input.addon"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "InputAddonRight",
  components: {},
  props: {
    input: Object,
    value: [String, Number],
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
  },
};
</script>
